
import {defineComponent} from 'vue';
import {AREA_ORIENTATION_HORIZONTAL, AreaOrientation} from './types';

export default defineComponent({
  name: 'oxd-divider',

  props: {
    style: {
      type: Object,
    },
  },

  computed: {
    classes(): object {
      return {
        'oxd-divider': true,
      };
    },
    areaOrientation(): AreaOrientation {
      return AREA_ORIENTATION_HORIZONTAL;
    },
  },
});
